import { FC } from 'react'
import { SelectInput } from 'react-admin'

const BOOLEAN_CHOICES = [
  { id: true, name: 'Yes' },
  { id: false, name: 'No' },
]

interface PropTypes {
  fieldId: string
  source: string
  /** Override default Yes/No choices if needed. */
  choices?: { id: boolean; name: string }[]
  onChange?: (value: unknown) => object
}

const BooleanFilter: FC<PropTypes> = ({ source, fieldId, choices = BOOLEAN_CHOICES, onChange }) => {
  return (
    <SelectInput
      choices={choices}
      label={false}
      source={`${source}.value.${fieldId}`}
      variant="outlined"
      margin="none"
      onChange={onChange}
      defaultValue={null}
    />
  )
}

export default BooleanFilter
